import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import API from "Payments/PaymentPage/API";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { useGetPaymentTypeVerbiage } from "../Shared/useGetPaymentTypeVerbiage";
import FnrButton, { ButtonText } from "UI/FnrButton3";

CancelPaymentButton.propTypes = {
  setErrorMsg: PropTypes.func.isRequired,
  setCancellationComplete: PropTypes.func.isRequired,
  isLoading: PropTypes.oneOf([null, "cancel", "finalize"]),
  setIsLoading: PropTypes.func.isRequired,
};

export default function CancelPaymentButton({
  setErrorMsg,
  setCancellationComplete,
  isLoading,
  setIsLoading,
}) {
  const { state, dispatch } = usePaymentPage();
  const { noun } = useGetPaymentTypeVerbiage();
  const [shouldSubmit, setShouldSubmit] = useState(false);
  const { paymentID } = state.modifyPayment;

  useEffect(() => {
    if (!shouldSubmit) return;
    setErrorMsg(null);

    const cancelPaymentCall = API.cancelPayment({
      paymentID,
    });

    setIsLoading("cancel");
    cancelPaymentCall
      .post()
      .then(() => {
        setCancellationComplete(true);
      })
      .catch((err) => {
        if (err.error === "already_processed") {
          dispatch({ type: "setModifyPaymentAlreadyCompleted" });
        } else {
          setErrorMsg(
            `Oh no! We were not able to cancel this ${noun}. Please try again, or contact help@flocknote.com with any questions.`
          );
        }

        setShouldSubmit(false);
        setIsLoading(null);
      });

    return () => {
      if (cancelPaymentCall.cancel) cancelPaymentCall.cancel();
    };
  }, [
    shouldSubmit,
    paymentID,
    setErrorMsg,
    dispatch,
    setCancellationComplete,
    noun,
    setIsLoading,
  ]);

  return (
    <FnrButton
      onClick={() => setShouldSubmit(true)}
      loading={isLoading === "cancel"}
      disabled={isLoading === "finalize"}
      fullWidth
    >
      <ButtonText>Cancel {noun}</ButtonText>
    </FnrButton>
  );
}
